
import {
  sku2array2
}
from './sku-ver2.js'
var params = {'6':[
  ['0','R','SM','RSS','?'],  // 0 - product R,SemiMount
  ['R','P','C','O','E','PR','M','RD'],  // 1 - shape
  ['C','D','LD'],  // 2 - color,natural or Lab Grown
  ['0.25','0.33','0.5','0.75','1','1.5','2','2.5','3','4','5','6','7','8','9','10','C2','C3'],  //  3 - Center Size
  ['SA','EM','TA','RU'],  // 4 - Center stone Color
  ['D','BDI','SA'],  // 5 - Head side color
  ['I','VS','SI','x1','x2'],  // 6 - Diamond Quality 
  ['S1', 'B1', 'P1', 'SS2', 'H1', 'H2','C1','T1TSPR', 'T1TSR', 'T1TSTR', 'T1TSP', 'H3','SS3','SS4','x3'],  //  7 - Head
  ['1','2','4','5','8','10','11','15','16','x1','x2','x3','x4','x5'],  // 8 - Shank
  ['0','R','P'],  // 9 - pkb
  ['D','BDI','SA','RU','EM'],  // 10 - pkb color
  ['0','CHR','UP','BD','PR','PV'],  // 11 - side stones
  ['1','2'],  // 12 - side length 
  ['D','BDI','BDID','SAD','RUD','EMD'],  // 13 ny side color
  ['0','1','2'],  // 14 - en   
  ['9','10','14','18','PT'],  // 15 - ring metal  
  ['W','Y','R'],  // 16 - head metal color
  ['W','Y','R'],  // 17 - shank metal color
  ['1','2'],  // 18 - carv length
  ['7','3','3.25','3.5','3.75','4','4.25','4.5','4.75','5','5.25','5.5','5.75','6','6.25','6.5','6.75','7','7.25','7.5','7.75','8','8.25','8.5','8.75','9','9.25','9.5','9.75','10'],  // 19 -  ring size
  ['0','1','2','3','4','5'],  // 20 - Engr font Ring
  ['US','UK','K','J','Z','KO','ZO','PPL','AF','JULER','9','10'],  // 21 - Market 
  ['0','S','C'],  // 22 - band type
  ['0','CHR','UP','BD','PR','PV'],  // 23 - band side setting
  ['D','BDI','BDID','SAD','RUD','EMD'],  // 24 - band side color
  ['1','2','3'],  // 25 - band side length  
  ['9','10','14','18','PT'],  // 26 - band metal  
  ['W','Y','R'],  // 27 - band metal color
  ['0','3','3.25','3.5','3.75','4','4.25','4.5','4.75','5','5.25','5.5','5.75','6','6.25','6.5','6.75','7','7.25','7.5','7.75','8','8.25','8.5','8.75','9','9.25','9.5','9.75','10'],  // 28 - band ring size
  ['0','1','2'],  // 29 - band carv              
  ['1','2','3'],  // 30 - band carv length
  ['0','1','2','3','4','5'],  // 31 - Engr font Band - 0- no engraving
   ]}
// PARAMS
// s - size (thumb,500,2000) default 500
// v - view (0,1,2,3) default = 0
// e - engraving (for r,b1,b2) for add to cart
// u - user diamond for add to cart(6 params)


var TOTAL_PARAM =32
var ring_list=[0,1,2,3,4,5,7,8,9,10,11,12,13,14,15,16,17,18,22,23,24];
var band_list=[6,19,20,21,28,29,30,25,26,27,31];

var ring_val = [];
var band_val = [];
var ring_val2 = [];
var band_val2 = [];
var version = '6';
var p = params[version];
var base = 35;


var alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ123456789';

function init() {
  var i;
//console.log(ring_list,p)
  for (i in ring_list) {
    ring_val.push(p[ring_list[i]].length);
  }
  for (i in band_list)
    band_val.push(p[band_list[i]].length);
    
  var n = 1;
  for (i = 0; i < ring_val.length; i++) {
    n = n * ring_val[i];
    ring_val2.push(n);
  }
  n = 1;
  for (i = 0; i < band_val.length; i++) {
    n = n * band_val[i];

    band_val2.push(n);
  }
  //console.log(ring_val)
  //console.log(band_val)
  //console.log(ring_val2)
 //  console.log(band_val2)
}
function param2skupart(in1, max_val, max_val2, base) {
  var sku = '';
  //var num = 0;
  var dec = 0;
 // alert(in1)
 // alert(max_val)
 var mul;
 var i;
  for (i = 0; i < max_val.length; i++) {
    if (i === 0)
      mul = 1;
    else
      mul = max_val2[i - 1];
    dec += in1[i] * mul;
  }
  // alert('decX'+String(dec))
  var sk = DecimalToBase(dec, base);
  sku = '';
  for (i = 0; i < sk.length; i++)
    sku = alphabet[sk[i]] + sku;
  return sku;
}
export function param2sku(in1) {
  var in2 = in1 //.split('-');

  in2[28] = in2[19]; //bs=rs
  

  var in3 = [];
  var in_ring = [];
  var in_band = [];
  //var j = 0;
  var i;
  var error = '';
  var res;
  if (in2.length < TOTAL_PARAM)
    error += 'param count in less than ' + String(TOTAL_PARAM);
  for (i = 0; i < TOTAL_PARAM; i++) {
    res = p[i].indexOf(in2[i]);
    if (res !== -1)
      in3.push(res);
    else {
      in3.push(0);
      error += 'error: ' + String(in2[i]) + ' not in index array ' + String(i) + ';';
      //console.log('ERROR SKU',in2,'not in','index',i,'originalsku',in1)
    }
  }
  // alert (in3)
  for (i = 0; i < ring_list.length; i++)
    in_ring.push(in3[ring_list[i]]);
  for (i = 0; i < band_list.length; i++)
    in_band.push(in3[band_list[i]]);
  var sku = version + param2skupart(in_ring, ring_val, ring_val2, base) + '0' + param2skupart(in_band, band_val, band_val2, base);
  // alert(sku)
  //console.log('return p2sku',sku, error)
  //console.log('param2sku',in1,in_ring,sku)
  
  return [sku, error];
}



 function sku2param(in1) {
  var resarray = [0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0];
  var in2 = in1.substring(1);
  var in3 = in2.split('0');
  var ring = sku2parampart(in3[0], ring_val2);
  //console.log('sku2param',in1,ring)
  if (in3.length===1)
    in3[1]=in3[0]
  var band = sku2parampart(in3[1], band_val2);
  var i;
  for (i = 0; i < ring.length; i++)
    resarray[ring_list[i]] = ring[i];
  for (i = 0; i < band.length; i++)
    resarray[band_list[i]] = band[i];
  if (resarray[2] === 3 || resarray[2] === 3)
    resarray[18] = 0;
  
  var res = [];
  for (i = 0; i < resarray.length; i++) {
    //if (res !== '') res += '-';
    res.push( p[i][resarray[i]]);
  }
  return res;
}

function sku2parampart(in2, max_temp) {
  var in1 = [];
  var pos;
  var i;
  for (i = 0; i < in2.length; i++) {
    pos = alphabet.indexOf(in2[i]);
    in1.push(pos);
  }
  var dec = 0;
  var param = [];
  // alert(in1);
  for (i = 0; i < in1.length; i++)
    dec += in1[i] * Math.pow(base, in1.length - i - 1);
  var maxlen = max_temp.length;
  for (i = 0; i < maxlen; i++) {
    if (i === maxlen - 1)
      param.unshift(Math.floor(dec));
    else
      param.unshift(Math.floor(dec / max_temp[maxlen - i - 2]));
    dec = Number(dec % max_temp[maxlen - i - 2]);
  	// alert(dec)
  	// alert(param)
  }
  return param;
}

function __DecimalToBaseRecur__(array, decimal, base) {
  array.push(decimal % base);
  // alert(decimal% base)
  var div = Math.floor(decimal / base);
  if (div === 0)
    return;
  __DecimalToBaseRecur__(array, div, base);
}

function DecimalToBase(decimal, base) {
  var array = [];
  __DecimalToBaseRecur__(array, decimal, base);
  return array;
}

 export function sku4band (sku) {
  let res= sku2param(sku)
  //res[20]='B'
  res[0]='0'
  let res2 =param2sku(res)[0]

  return res2
}
 export function sku4ring (sku) {
  let res= sku2param(sku)
 // res[0]='R'
  res[22]='0'
  let res2 =param2sku(res)[0]
  ////console.log('res',sku,'>',res2)
  return res2
}
 export function sku2array(in1) {
  
  if (in1[0]==='2')
   return sku2array2(in1)
  
  let res= sku2param(in1)
  //console.log('sku2array',in1,res)
  let res2={}
 
     if (res[15]==='9' )
      res[15]='10'
     if (res[26]==='9')
      res[26]='10'
    if (!['K','J','Z','KO','ZO','PPL'].includes(res[21]))
      res[21]='K'
     res2['ce'] =  res[2]
     res2['cec'] =  res[4]
     res2['ds'] =  res[1]
     
     res2['dctw'] =  res[3]
     res2['head'] =  res[7]
     res2['headc'] =    res[5]
     res2['pkb'] =    res[9]
     res2['sh'] =    res[8]
     res2['rset'] =  res[11]
     res2['rsetc'] =  res[13]
     res2['rsetl'] =  res[12]
     res2['ren'] =  res[14]
     res2['renl'] =  res[18]
     res2['rmet'] =  res[15]
     res2['pkbc'] =  "D"
     res2['hmetc'] =  res[16]
     res2['smetc'] = res[17]
     res2['band'] =  res[22] 
     res2['bset'] =  res[23] 
     res2['bsetc'] =  res[24] 
     res2['bsetl'] =  res[25] 
     res2['bmet'] =  res[26] 
     res2['bmetc'] =  res[27] 
     res2['rs'] =  res[19] 
     res2['bs'] =  res[28] 
     res2['ben'] =  res[29]
     res2['benl'] =  res[30]
     res2['dq'] =  res[6]
    
    res2['store']= res[21]



//console.log('sku changed from ',in1,'to',res2['sku'])
  return res2   
  } 
init()